import React from 'react';

interface LinkModifierInput {
  type: string;
  link: string;
  [key: string]: unknown;
}

interface LinkModifierResult {
  type: string;
  link: string;
  label?: React.ReactNode;
  [key: string]: unknown;
}

export const linkModifier = ({ type, link, ...props }: LinkModifierInput, text?: string): LinkModifierResult => {
  switch (type) {
    case 'Phone':
      return {
        type,
        link: `tel:${link}`,
        label: (
          <>
            <div>{link}</div>
            <div>{text === `tel:${link + type}` ? 'Copied' : 'Copy link'}</div>
          </>
        ),
        ...props,
      };
    case 'Email':
      return {
        type,
        link: `mailto:${link}`,
        label: (
          <>
            <div>{link}</div>
            <div>{text === `mailto:${link + type}` ? 'Copied' : 'Copy link'}</div>
          </>
        ),
        ...props,
      };
    case 'Telegram':
      return {
        type,
        link:
          link.startsWith('https://t.me') || link.startsWith('http://t.me')
            ? link
            : link.startsWith('@')
            ? `https://t.me/${link.slice(1)}`
            : `https://t.me/${link}`,
        ...props,
      };
    default:
      return { type, link, ...props };
  }
};
